
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/di-che-ramo-sei/educational-danni/[slug]",
      function () {
        return require("private-next-pages/di-che-ramo-sei/educational-danni/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/di-che-ramo-sei/educational-danni/[slug]"])
      });
    }
  